import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, state } = useLocation();

  useEffect(() => {
    if(!pathname?.includes('shop') || (state && state.scrollToTop)){ 
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  
  return null;
}

export default ScrollToTop